import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../core/api/module';
import { ActionType } from '../../../core/redux/actionType';


const KEY_ACTION = ActionType.DeleteQuestionRequest;
const ACTIONS    = [
  ActionType.DeleteQuestionRequest,
  ActionType.DeleteQuestionResponse,
  ActionType.DeleteQuestionError,
];


type Payload = boolean;

type Meta = {
  questionId: number;
  projectId: number;
};


/**
 * Dispatch this action to delete the dev plan items made by the user
 */
export const deleteQuestionAction = (
  projectId: number,
  participantId: number,
  questionId: number,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.DeleteQuestion,
  headers:  { 'content-type': 'application/json', 'accept': 'application/json' },
  body:     state => JSON.stringify({
    projectId,
    participantId,
    questionId,
  }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { questionId, projectId }),
  bailout:  state => !!getLoading(state, KEY_ACTION, questionId),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const questionId = action.meta.questionId;
  if (isLoading) {
    return addLoading(state, KEY_ACTION, questionId);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, questionId);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, questionId);

  return R.assocPath(
    ['selectedQuestions', `${action.meta.projectId}`],
    successState.selectedQuestions?.
      [`${action.meta.projectId}`].
      filter(item => item.questionId !== questionId || item.required) ?? [],
    R.dissocPath(['selectedQuestions', `${action.meta.projectId}`, `${questionId}`], successState),
  );  
};


export const deleteQuestionReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
